import React from 'react';
import { Content, Header, DateItem, ShareItem, LocationItem, Section, Title, Skeleton } from './DashboardSkeleton.styles';
import { useTranslation } from '@shared/core';
import { Box } from '@withjoy/joykit';

export const DashboardSkeleton: React.FC = () => {
  const { t2 } = useTranslation('adminDashboardV2');
  const { loading } = t2('text');

  return (
    <>
      <Header role="status" aria-label={loading}>
        <DateItem />
        <LocationItem />
        <ShareItem />
      </Header>

      {[...Array(4)].map((_, index) => (
        <Section key={`skeleton-${index}`}>
          <Title />
          <Content />
        </Section>
      ))}
    </>
  );
};

export const HeaderSkeleton: React.FC = () => {
  return (
    <Box
      justifyContent={'space-between'}
      display="flex"
      flexWrap={'nowrap'}
      paddingTop={['2rem', '2.5rem']}
      paddingLeft={{
        _: '1.5rem',
        sm: '3rem'
      }}
      paddingRight={{
        _: '1.5rem',
        sm: '2.5rem'
      }}
      marginBottom={{
        _: '1rem',
        xs: '0.5rem'
      }}
    >
      <Skeleton height={`3rem`} width={`10rem`} marginRight="0.5rem" />
      {/* style attribute to override 0.25rem border-radius from <Skeleton /> */}
      <Skeleton height={'3rem'} width={`${112 / 16}rem`} style={{ borderRadius: '3rem' }} />
    </Box>
  );
};
